/* eslint-disable no-unused-vars,no-restricted-syntax,guard-for-in */
import * as ActionTypes from '../actions/types/SeatingChartActionTypes';

const initialState = {
  busy: false,
  byEventId: {},
  events: [],
  selectedEvent: {},
  seatingChart: {},
  tablesByUuid: {},
  tables: [],
  seatsByUuid: {},
  seatsByGuestDistinction: {},
  editTableData: {},
  addTableData: {},
  seatsByTableUuid: {},
  listView: true,
  selected: {},
  isDetailed: false,
  reorderTable: ''
};

const chartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.LOAD_EDIT_TABLE: {
      const editTableData = action.payload.data;
      return Object.assign(
        {},
        state,
        { editTableData }
      );
    }
    case ActionTypes.CHANGE_SELECTED_CHART: {
      const byEventId = state.byEventId;
      let selected = {};
      selected = action.payload.uuid;
      Object.keys(byEventId)
          .forEach((key) => {
            if (action.payload.uuid === byEventId[key][0].uuid) {
              selected = { event: key, uuid: byEventId[key][0].uuid, name: byEventId[key][0].name };
            }
          });
      return Object.assign(
        {},
        state,
        { selected }
      );
    }
    case ActionTypes.REQUEST_CHART: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_CHART: {
      const seatingChart = action.payload.data;
      const byEventId = state.byEventId;
      let selected = {};
      const seatingChartTables = seatingChart.tables;
      const reorderTable = '';
      const tablesByUuid = {};
      const seatsByUuid = {};
      const seatsByTableUuid = {};
      const seatsByGuestDistinction = { guests: {}, couple: {} };
      const tables = [];
      if (seatingChartTables.length > 0) {
        seatingChartTables.forEach((table) => {
          const newTable = table;
          const seatViews = table.seats;
          newTable.num_filled_seats = seatViews.length;
          const tableSeats = Array(table.num_seats).fill(null);
          if (seatViews.length > 0) {
            seatViews.forEach((seat) => {
              const newSeat = seat;
              newSeat.isEmpty = false;
              seatsByUuid[seat.uuid] = newSeat;
              if (seat.couple_role != null) {
                seatsByGuestDistinction.couple[newSeat.couple_role] = newSeat;
              } else {
                seatsByGuestDistinction.guests[newSeat.guest_id] = newSeat;
              }
              tableSeats[newSeat.display_order - 1] = newSeat;
            });
          }
          // Fill in empty seats if necessary
          for (let i = 0; i < table.num_seats; i += 1) {
            if (tableSeats[i] == null) {
              tableSeats[i] = { table_uuid: table.uuid, display_order: i + 1, isEmpty: true, uuid: i };
            }
          }

          seatsByTableUuid[table.uuid] = tableSeats;
          newTable.seats = tableSeats;
          tables.push(newTable);
          tablesByUuid[table.uuid] = newTable;
        });
      }
      Object.keys(byEventId).forEach((key) => {
        if (seatingChart.uuid === byEventId[key][0].uuid) {
          selected = { event: key, uuid: byEventId[key][0].uuid, name: byEventId[key][0].name };
        }
      });
      return Object.assign(
        {},
        state,
        { busy: false },
        { seatingChart, tablesByUuid, seatsByUuid, tables, seatsByTableUuid, seatsByGuestDistinction, selected, reorderTable }
      );
    }
    case ActionTypes.REQUEST_CHARTS: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_CHARTS: {
      const events = [];
      const seatingCharts = action.payload;
      const byEventId = seatingCharts.event_to_charts_map;
      Object.keys(byEventId).forEach((key) => {
        events.push({ event: key, uuid: byEventId[key][0].uuid, name: byEventId[key][0].name });
      });
      return Object.assign(
        {},
        state,
        { busy: false },
        { byEventId, events }
      );
    }
    case ActionTypes.CREATE_TABLE: {
      const tables = [];
      return Object.assign(
        {},
        state,
        { tables }
      );
    }
    case ActionTypes.CHANGE_VIEW: {
      const listView = !state.listView;
      return Object.assign(
        {},
        state,
        { listView }
      );
    }
    case ActionTypes.SHOW_DETAILS: {
      const isDetailed = !state.isDetailed;
      return Object.assign(
        {},
        state,
        { isDetailed }
      );
    }
    case ActionTypes.REQUEST_TABLES: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_TABLES: {
      return Object.assign(
        {},
        state,
        { busy: false },
      );
    }
    case ActionTypes.REORDER_TABLES: {
      const tables = state.tables.slice();
      if (tables.length <= 0) {
        return Object.assign(
          {},
          state,
          { busy: false });
      }

      const sourceIndex = action.payload.sourceIndex;
      const hoverIndex = action.payload.hoverIndex;

      const direction = (hoverIndex > sourceIndex) ? 1 : -1;
      let index = sourceIndex;
      while (index !== hoverIndex) {
        tables[index] = state.tables[index + direction];
        index += direction;
      }

      tables[hoverIndex] = state.tables[sourceIndex];

      const tablesByUuid = {};

      tables.forEach((table) => {
        tablesByUuid[table.uuid] = table;
      });

      return Object.assign(
        {},
        state,
        { busy: false },
        { tables, tablesByUuid }
      );
    }
    case ActionTypes.REORDER_SEATS: {
      const table = { ...state.tablesByUuid[action.payload.tableUuid] };
      if (table == null) {
        return Object.assign(
          {},
          state,
          { busy: false });
      }
      const seat = action.payload.seat;
      let sourceIndex = action.payload.sourceIndex;
      const hoverIndex = action.payload.hoverIndex;
      const forceReorder = action.payload.forceReorder;
      const fromTable = action.payload.fromTable;
      let reorderTable = state.reorderTable;

      const seats = table.seats.slice();
      if (seats.length > 0) {
        if (fromTable) {  // Seat is swapping tables, re-order dragged seat's source table if not already done
          reorderTable = table.uuid;
          for (let idx = 0; idx < seats.length; idx += 1) {
            const seatDisplayOrder = table.seats[idx].display_order;
            seats[seatDisplayOrder - 1] = table.seats[idx];
          }
          // Temporarily replace moving seat (since it's not at the table during the move)
          seats[sourceIndex] = { table_uuid: table.uuid, display_order: sourceIndex + 1, isEmpty: true, uuid: seats[sourceIndex].uuid };
        } else {
          if (reorderTable !== '' || forceReorder) {  // We dragged a seat away and are either bringing it back, or dropped it on a full/non-existent table
            const originalSeat = state.seatsByUuid[seat.uuid];
            if (originalSeat == null) {
              return Object.assign(
                {},
                state,
                { busy: false });
            }
            for (let idx = 0; idx < table.seats.length; idx += 1) {
              if (table.seats[idx].uuid === originalSeat.uuid) {
                table.seats[idx] = originalSeat; // Replace the previously emptied seat
                sourceIndex = idx;
                break;
              }
            }
          }

          // Are we moving the guests up or down, depending on which direction the dragged guest is going
          const direction = (hoverIndex > sourceIndex) ? 1 : -1;
          let index = sourceIndex;
          while (index !== hoverIndex) {
            seats[index] = table.seats[index + direction];
            index += direction;
          }

          seats[hoverIndex] = table.seats[sourceIndex];
          reorderTable = '';
        }
      }

      table.seats = seats;
      const tables = [];
      const tablesByUuid = {};
      for (let i = 0; i < state.tables.length; i += 1) {
        if (state.tables[i].uuid === table.uuid) {
          tables[i] = table;
          tablesByUuid[table.uuid] = table;
        } else {
          tables[i] = state.tables[i];
          tablesByUuid[state.tables[i].uuid] = state.tables[i];
        }
      }

      return Object.assign(
        {},
        state,
        { busy: false },
        { tables, tablesByUuid, reorderTable },
      );
    }
    default: return state;
  }
};

export default chartReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/seatingChart.js
 **/